<template>
  <v-layout>
    <v-toolbar dark color="#2C404B">
        <router-link to="/">
          <img src="https://static.licdn.com/sc/h/95o6rrc5ws6mlw6wqzy0xgj7y">
        </router-link>
        
        <v-spacer></v-spacer>
        <v-toolbar-side-icon></v-toolbar-side-icon>
         <v-toolbar-items class="hidden-sm-and-down">
        </v-toolbar-items>
    </v-toolbar>
  </v-layout>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'One Drive'
    }
  }
}
</script>
